export default "__VITE_ASSET__BGtTt_sf__"